import PartnerReferral from '../../../types/responseSchema/partnerReferral';
import env from '../../env';
import { backendAuthenticatedAxios } from '..';

import { AxiosResponse } from 'axios';

const getDownstreamReferrals = async (fundingAppId: number): Promise<AxiosResponse<PartnerReferral[]>> => {
  const response = await backendAuthenticatedAxios.get<PartnerReferral[]>(
    `${env.var.API_URL_EXTERNAL}/quote/refer?id=${fundingAppId}`,
  );
  console.log('Partner Referrals response:', response);

  return response;
};

export default getDownstreamReferrals;
